const blocksBuild = {
    state: {
        selectedBlock: {},
        newBlock: {},
        deletedBlock: {},
        copiedBlock: {},
        updatedBlockName: {},
        variables: []
    },
    mutations: {
        'SET_SELECTED_BLOCK' (state, block) {
            state.selectedBlock = block
        },
        'SET_NEW_BLOCK' (state, block) {
            state.newBlock = block
        },
        'SET_DELETED_BLOCK' (state, block) {
            state.deletedBlock = block
        },
        'SET_COPIED_BLOCK' (state, block) {
            state.copiedBlock = block
        },
        'UPDATE_BLOCK_NAME' (state,block) {
            state.updatedBlockName = block
        },
        'SET_VARIABLES' (state,variables) {
            state.variables = variables
        },
        'PUSH_VARIABLE' (state, variable) {
            state.variables.push(variable)
        }
    },
    actions: {
        setSelectedBlock({commit}, block) {
            commit('SET_SELECTED_BLOCK', block)
        },
        setNewBlock({commit}, block) {
            commit('SET_NEW_BLOCK', block)
        },
        setDeletedBlock({commit}, block) {
            commit('SET_DELETED_BLOCK', block)
        },
        setCopiedBlock({commit}, block) {
            commit('SET_COPIED_BLOCK', block)
        },
        updateBlockName({commit}, block) {
            commit('UPDATE_BLOCK_NAME', block)
        },
        setVariables({commit}, variables) {
            commit('SET_VARIABLES', variables)
        },
        pushVariable({commit}, variable) {
            commit('PUSH_VARIABLE', variable)
        }
    },
    getters : {
        getGlobalAttributes(state) {
            return state.variables;
        }
    }
}

export default blocksBuild
